/**
 * Created by dinesh on 13/6/17.
 */
import {RouterModule, Routes} from '@angular/router';
import { ReportViewerComponent } from './shared/report-viewer/report-viewer.component';


const routes: Routes = [
  { path: '', redirectTo: '/sign-in', pathMatch: 'full' },
  { path: 'student', loadChildren: () => import('./student/student.module').then(m => m.StudentModule) },
  { path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule) },
  { path: 'instructor-admin', loadChildren: () => import('./instructor-admin/instructor-admin.module').then(m => m.InstructorAdminModule) },
  { path: 'instructor', loadChildren: () => import('./instructor/instructor.module').then(m => m.InstructorModule) },
  { path: 'admin/control', loadChildren: () => import('./session-control/session-control.module').then(m => m.SessionControlModule) },
  { path: 'instructor/control', loadChildren: () => import('./session-control/session-control.module').then(m => m.SessionControlModule) },
  { path: 'instructor-admin/control', loadChildren: () => import('./session-control/session-control.module').then(m => m.SessionControlModule) },
  { path: 'student/control', loadChildren: () => import('./session-control/session-control.module').then(m => m.SessionControlModule) },
  { path: 'report/viewer', component: ReportViewerComponent,
    data: { title: 'BankExec® Report Viewer' }
   },
 ];
export const routing = RouterModule.forRoot(routes);
